import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Icon } from "../components/Icon";
import { SiteHeader } from "../components/SiteHeader";
import { useAuth } from "../auth/AuthProvider";

export function LoginPage() {
  const { session, signIn, isDemo } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const destination = (location.state as { from?: string } | null)?.from ?? "/dashboard";

  if (session) return <Navigate to={destination} replace />;

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setWorking(true);
    setError(null);
    try {
      await signIn(isDemo ? email || "demo@rsm.local" : email, isDemo ? "demo" : password);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Sign in could not be completed.");
    } finally {
      setWorking(false);
    }
  };

  return (
    <div className="login-page">
      <SiteHeader quiet />
      <main className="login-shell">
        <section>
          <p className="section-label">Private workspace</p>
          <h1>Every meeting, in one place.</h1>
          <p>Sign in to the RSM central dashboard to see booking briefs, live updates, and availability.</p>
        </section>
        <form className="login-form" onSubmit={submit}>
          <h2>{isDemo ? "Dashboard preview" : "Sign in"}</h2>
          {error ? <div className="error-banner" role="alert">{error}</div> : null}
          {!isDemo ? (
            <>
              <label><span>Email</span><input type="email" required autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
              <label><span>Password</span><input type="password" required autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>
            </>
          ) : <p className="demo-note">Supabase environment variables are not set, so this opens a local, read-only dashboard preview.</p>}
          <button className="button button--primary button--wide" type="submit" disabled={working}>
            {working ? "Opening…" : isDemo ? "Open preview" : "Sign in"} <Icon name="arrow" />
          </button>
        </form>
      </main>
    </div>
  );
}
